import React from 'react'
import { Box,Text,Image } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { FaCoffee, FaGuitar} from 'react-icons/fa'
import IntroImg from '../assets/images/Programming-pana.svg'

const IntroSeciton = () => {
    return (
        <motion.div
            style={{width: "100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}
            initial={{opacity: 0 }}
            animate={{opacity: 1 }}
            transition={{
                duration: 0.5,
                ease: "easeIn",
                delay: 0.75
            }}
        >
            <Box w="60%" pl="7rem">
                <Text fontSize="1.25rem" color="primary.light">What's up, I am</Text>
                <Text mt="-1rem" fontSize="5rem" fontWeight="600" color="text.light">Chetas Sharma.</Text>
                <Text mt="-2.25rem" fontSize="5rem" fontWeight="600" color="text.dark">
                    I am <Text color="primary.light" as={"span"}>crazy</Text> for Web
                </Text>
                <Text w="60%" mt="2rem" fontSize="1.15rem" color="text.dark">
                    Aspiring Software Developer who plays with stuff on the web,
                    build apps and contribute to open source as well.
                    Do checkout my <Text as={"span"} color="primary.light"> <FaGuitar style={{ paddingTop: "5px", display: "inline" }} size={23} /></Text> covers on my instagram.
                    If you are fond of Indie music, let's meet over a
                    <Text ml="0.25rem" as={"span"} color="primary.light"> <FaCoffee style={{ paddingTop: "5px", display: "inline" }} /></Text> .
                </Text>
            </Box>
            <motion.div 
                style={{display: "flex", paddingRight: "4.5rem"}}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{
                    duration: 0.75,
                    ease: "easeIn",
                    delay: 0.75
                }}
            >
                <Image src={IntroImg} boxSize="550px" alt="banner image" />
            </motion.div>
        </motion.div>
    )
}

export default IntroSeciton
